<template>
  <svg
    :class="[className, {spin}]"
    fill="none"
    :height="height"
    viewBox="0 0 16 16"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.4829 9.87987C14.1574 11.0027 13.5458 12.0216 12.708 12.837C11.8703 13.6524 10.8352 14.2363 9.70397 14.5314C8.57279 14.8265 7.38436 14.8228 6.25506 14.5206C5.12575 14.2183 4.09429 13.628 3.2617 12.8074C2.4291 11.9868 1.8239 10.9639 1.50538 9.83914C1.18686 8.71432 1.16593 7.52607 1.44464 6.39074C1.72335 5.2554 2.29215 4.21192 3.09533 3.36247C3.89851 2.51302 4.90853 1.88674 6.02649 1.54494" :stroke="fill" stroke-linecap="round" stroke-linejoin="bevel" stroke-width="1.5"/>
  </svg>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
    spin: {
      type: Boolean,
      required: false,
      default: true
    }
  },
};

</script>

<style lang="scss" scoped>
.spin {
  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
@keyframes spin {
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
}
</style>